<template>
  <div class="order-skeleton">
    <div class="order-skeleton__img">
      <img
        src="/assets/placeholder.svg"
        alt="product"
        loading="eager"
        fetchpriority="high"
        width="45"
        height="45"
      >
    </div>
    <div class="order-skeleton__details">
      <div class="order-skeleton__details_header-section">
        <span class="order-skeleton__details_title skeleton-line" />
        <span class="order-skeleton__details_sku skeleton-line" />
      </div>
      <span class="order-skeleton__details_description skeleton-line" />
      <span class="order-skeleton__details_description skeleton-line" style="margin-top: -8px;" />
      <div class="order-skeleton__details_footer-section">
        <span class="order-skeleton__details_price skeleton-line" />
        <span class="order-skeleton__details_action skeleton-line" />
      </div>
    </div>
  </div>
</template>

<script async>
export default {
  name: 'OrderSkeleton'
}
</script>

<style scoped lang="scss">
.skeleton-line {
  display: block;
  width: 100%;
  height: 16px;
  border-radius: 6px;
  background: #F0F0F0;
}

.order-skeleton {
  display: flex;
  column-gap: 20px;
  padding: 10px;
  border-bottom: 1px solid #EEEEEE;

  &__img {
    min-width: 73px;
    height: 73px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.15);
    background-color: #fff;
  }

  &__details {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    &_header-section {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media only screen and (max-width: 991px) {
        flex-direction: column;
        align-items: flex-start;
        row-gap: 16px;
      }
    }

    &_footer-section {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media only screen and (max-width: 991px) {
        flex-direction: column;
        align-items: flex-start;
        row-gap: 16px;
      }
    }

    &_title {
      width: 50%;
    }

    &_sku {
      width: 33%;

      @media only screen and (max-width: 991px) {
        height: 24px;
      }
    }

    &_description {
      width: 75%;
    }

    &_price {
      width: 25%;
    }

    &_action {
      width: 33%;
      height: 20px;

      @media only screen and (max-width: 991px) {
        width: 100%;
      }
    }
  }
}
</style>
